import {
  formatMeetingDebugReport,
  type MeetingDebugCard,
} from '@/features/meeting-debug/meeting-debug.cards';

import { uploadFeedbackAttachmentToS3 } from '../app-logs/app-logs.utils';

export type MeetingDebugAttachment = {
  card: MeetingDebugCard;
  title: string;
};

export async function uploadMeetingDebugReport({
  card,
  title,
}: MeetingDebugAttachment): Promise<string[]> {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return [
    await uploadFeedbackAttachmentToS3(
      new File(
        [formatMeetingDebugReport(card, title)],
        `meeting-debug-${(card.meetingId ?? card.key).replace(/[^\w-]/g, '_')}-${timestamp}.txt`,
        { type: 'text/plain' }
      )
    ),
  ];
}
